import { createElementBlock as a, openBlock as e, createStaticVNode as l } from "vue";
const p = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 21"
};
function c(r, t) {
  return e(), a("svg", p, [...t[0] || (t[0] = [
    l('<g clip-path="url(#a)"><path fill="#FF5F00" d="M17.173 4.632H9.826v12.735h7.347z"></path><path fill="#EB001B" d="M10.38 11c0-2.588 1.259-4.883 3.194-6.368A8.54 8.54 0 0 0 8.398 2.9C3.755 2.9 0 6.522 0 11s3.755 8.1 8.397 8.1a8.54 8.54 0 0 0 5.178-1.733c-1.936-1.462-3.196-3.78-3.196-6.367"></path><path fill="#F79E1B" d="M27 11c0 4.477-3.755 8.1-8.396 8.1a8.54 8.54 0 0 1-5.178-1.733c1.959-1.485 3.195-3.78 3.195-6.367s-1.26-4.883-3.195-6.368A8.54 8.54 0 0 1 18.604 2.9C23.245 2.9 27 6.545 27 11"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0-2.5h27v27H0z"></path></clipPath></defs>', 2)
  ])]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
